import { render, staticRenderFns } from "./KartuHargaPokokProduksi.vue?vue&type=template&id=172fc076"
import script from "./KartuHargaPokokProduksi.vue?vue&type=script&lang=js"
export * from "./KartuHargaPokokProduksi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports